import { render, staticRenderFns } from "./InfoArticle.vue?vue&type=template&id=2ab9c51c&"
import script from "./InfoArticle.vue?vue&type=script&lang=js&"
export * from "./InfoArticle.vue?vue&type=script&lang=js&"
import style0 from "./InfoArticle.vue?vue&type=style&index=0&id=2ab9c51c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports